<template>
  <div class="set_main">
    <div class="account-tit">
      <h1 class="title">
        {{ $t('message["19"]') }}
      </h1>
    </div>
    <a-form
      :form="form"
      :hide-required-mark="true"
      class="inquiry-detail"
      @submit="handleSubmit"
    >
      <a-form-item
        class="code_form_item"
        :label="emailTit"
      >
        <a-input
          v-decorator="decorators.email"
          :placeholder="newEmailPlace"
        />
      </a-form-item>
      <a-form-item
        :label="validTit"
        class="password-box"
      >
        <a-input
          v-decorator="decorators.checkcode"
          :placeholder="emailValid"
        />
        <get-code
          class="find-pwd-link ml-16"
          :email="form.getFieldValue('email')"
          type="4"
          :is-disabled="false"
          @getRes="sendEmailCode"
        />
      </a-form-item>
      <a-form-item>
        <div class="form_btn">
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["1161"]') }}
          </a-button>
          <a-button
            type="default"
            @click="resetForm"
          >
            {{ $t('message["896"]') }}
          </a-button>
        </div>
      </a-form-item>
    </a-form>
    <bind-dialog
      ref="bindDialog"
      bind-type="email"
      :value="form.getFieldValue('email')"
    />
  </div>
</template>

<script>
import BindDialog from '@/components/pc/account/BindDialog'
import getCode from '@/components/pc/GetCode'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  components: {
    getCode,
    BindDialog
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('account/modify', ['decorators']),
    newEmailPlace () {
      return this.$t('message["819"]')
    },
    emailValid () {
      return this.$t('message["829"]')
    },
    validTit () {
      return this.$t('message["1433"]')
    },
    emailTit () {
      return this.$t('message["1505"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('account/modify', ['bindEmail']),
    ...mapMutations('account/modify', ['setUserid']),
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.form.validateFields(async (err, values) => {
            if (!err) {
              const chain = await this.bindEmail()
              chain.params(values)
                .onSuccess(res => {
                  this.$router.push({ name: 'AccountInfo' })
                })
                .onNetSuccess(raw => {
                  let res = raw.data
                  if (res.error === 104) {
                    this.$refs.bindDialog.changeLimitDialog(true)
                    this.setUserid(res.payload.binduserid)
                  } else {
                    if (res.error) {
                      // this.$message.warn(res.message || res.payload[0].message)
                      if (res.error !== 102) {
                        this.$message.warn(res.message || res.payload[0].message)
                      }
                    }
                  }
                })
                .setForm(this.form)
                .config({ warn: false })
                .fetch()
            }
          })
        }
      })
    },
    // 跳转到个人信息
    resetForm () {
      this.$router.push({ name: 'AccountInfo' })
    },
    sendEmailCode (res) {
      console.log(res)
    }
  }
}
</script>

<style scoped lang="scss">
.set_main {
 padding: 24px 40px;
 .account-tit {
   margin-bottom: 24px;
 }
  .form_btn {
  button {
    margin-right: 16px
  }
}
}
</style>
